'use client';
import './mobileIntro.scss';
import React from 'react';
import CloseIcon from '@mui/icons-material/Close';
/* eslint-disable @next/next/no-img-element */
import {
  DialogContent,
  Divider,
  IconButton,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
} from '@mui/material';

import { MixpanelEvent } from '@/services/eventEnums';
import { MixpanelTracking } from '@/services/mixpanel';
import CorporateFareOutlinedIcon from '@mui/icons-material/CorporateFareOutlined';

import ExploreOutlinedIcon from '@mui/icons-material/ExploreOutlined';
import ElectricBoltOutlinedIcon from '@mui/icons-material/ElectricBoltOutlined';
import SkywatchLogo from '@/assets/img/sw-new-logo.svg';
import ExploreLogo from '@/assets/img/sw-logo-explore.svg';
import { useTranslation } from 'react-i18next';

export default function MobileIntroScreen({
  showContentComponent,
  dialogFlowRef,
  setShowContentComponent,
  setOpen,
  allSteps,
}: {
  showContentComponent: any;
  dialogFlowRef: any;
  setShowContentComponent: any;
  setOpen: any;
  allSteps: any;
}) {
  const { t } = useTranslation('orderImagery');
  return (
    <>
      <IconButton
        name="Close Delete Item"
        aria-label="close-delete-item-dialog"
        className="close-btn"
        onClick={() => {
          setOpen(false);
          MixpanelTracking.getInstance().track(MixpanelEvent.EXPLORE_MOBILE_INTRO_DIALOG_CLOSE);
        }}
        sx={{
          position: 'absolute',
          right: 8,
          top: 15,
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent
        className="mbl-intro-dialog-content"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginTop: '20px',
        }}
      >
        <img className="skywatch-logo" src={SkywatchLogo.src} />
        <img className="explore-logo" src={ExploreLogo.src} />
        <Divider sx={{ color: '#F4F6F5', width: '100%', borderColor: '#F4F6F5' }} />
        <Typography variant="h6" sx={{ fontSize: '18px' }}>
          {t('whatHelp', 'What can we help you with?')}
        </Typography>
        <List className="mbl-intro-content-list" component="nav">
          <ListItemButton
            className="mbl-intro-content-btn"
            sx={{ '&:hover': { backgroundColor: '#314158' } }}
            onClick={() => {
              dialogFlowRef.current = 'org_img';
              setShowContentComponent(allSteps['org_img']);
              MixpanelTracking.getInstance().track(
                MixpanelEvent.EXPLORE_MOBILE_INTRO_ORG_IMAGE_CLICK
              );
            }}
          >
            <ListItemIcon>
              <CorporateFareOutlinedIcon />
            </ListItemIcon>
            <ListItemText primary={t('searchImagery', 'Search imagery for my organization')} />
          </ListItemButton>

          <ListItemButton
            className="mbl-intro-content-btn"
            sx={{ '&:hover': { backgroundColor: '#314158' } }}
            onClick={() => {
              dialogFlowRef.current = 'need_img';
              setShowContentComponent(allSteps['need_img']);
              MixpanelTracking.getInstance().track(
                MixpanelEvent.EXPLORE_MOBILE_INTRO_NEED_IMAGE_CLICK
              );
            }}
          >
            <ListItemIcon>
              <ElectricBoltOutlinedIcon />
            </ListItemIcon>
            <ListItemText primary={t('needImage', 'I need an image right now')} />
          </ListItemButton>
          <ListItemButton
            className="mbl-intro-content-btn"
            sx={{ '&:hover': { backgroundColor: '#314158' } }}
            onClick={() => {
              dialogFlowRef.current = 'explore';
              setShowContentComponent(allSteps['explore']);
              MixpanelTracking.getInstance().track(
                MixpanelEvent.EXPLORE_MOBILE_INTRO_BROWSING_CLICK
              );
            }}
          >
            <ListItemIcon>
              <ExploreOutlinedIcon />
            </ListItemIcon>
            <ListItemText primary={t('justBrowsing', 'Just browsing / exploring')} />
          </ListItemButton>
        </List>
      </DialogContent>
    </>
  );
}
